import React from 'react'

const PrintPageBreak = () => <div className="page-break"></div>

export default React.memo(PrintPageBreak)
